/**
 * Finds one of the device's items by a custom predicate. Returns the item, or {} when not found.
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @param {Function} predicate - (item) => boolean, evaluated only among the device's items
 * @returns {Object} the matching item or {}
 */
export const findDeviceItem = (items, deviceId, predicate) => {
    const item = items?.find((currentItem) => currentItem.deviceId === deviceId && predicate(currentItem));

    return item ? item : {};
};
